<template>
  <div class="filters">
    <h3 class="filters__heading">{{ $t('filters.search') }}</h3>

    <slider
      :property="flatProperties['area']"
      :title="$t('singleFlat.area')"
      units="m"
      :lazy="lazy"
      fixed="0"
      queryParam="s_metry"
    ></slider>
    <!-- <slider
      :property="flatProperties['price']"
      :title="$t('singleFlat.price')"
      units="PLN"
      :lazy="lazy"
      fixed="0"
    ></slider> -->
    <slider
      :property="flatProperties['floor']"
      :title="$t('singleFlat.floor')"
      :lazy="lazy"
      queryParam="s_pietro"
    ></slider>
    <slider
      :property="flatProperties['rooms']"
      :title="$t('singleFlat.rooms')"
      :lazy="lazy"
      queryParam="s_pokoje"
    ></slider>

    <div class="filters__counter" v-if="counter">
      <p class="filters__quantity">
        {{ $t('filters.criteria') }}: {{ flats.length }}
      </p>
    </div>

    <button @click="clearFilters" class="filters__button" v-if="clear">
      <Icon :medium="true"> <img src="@/assets/bin.png" alt=""/></Icon>
      <span>{{ $t('filters.remove') }}</span>
    </button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
// Components
import slider from '@/components/form/range-slider.vue';
// import amenities from '@/components/form/amenities.vue';
import Icon from '@/components/icon';

export default {
  name: 'filters',
  props: {
    lazy: {
      type: Boolean,
      default: true,
    },
    counter: {
      type: Boolean,
      default: true,
    },
    clear: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    slider,
    // amenities,
    Icon,
  },
  computed: {
    ...mapState({ flatProperties: state => state.browser.flatProperties }),
    flats() {
      return this.$store.getters.GET_FILTERED_FLATS;
    },
    isFloor() {
      return this.$route.name == 'floor';
    },
  },
  methods: {
    ...mapMutations({
      clearFilters: 'CLEAR_FILTERS',
    }),
  },
};
</script>

<style lang="scss" scoped>
.filters {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: center;
  width: 100%;
  height: 100%;
  padding-top: $topbarHeight;
}

.filters__heading {
  margin-bottom: 35px;
  font-size: 22px;
  font-weight: 500;
  text-transform: uppercase;
  text-align: left;
}

.filters__quantity {
  text-align: left;
  font-size: 24px;
  font-weight: 400;
  color: #000;
  span {
    font-size: 14px;
    margin: 0 2px;
  }
}

.filters__counter {
  margin-top: 6px;
  text-align: center;
  font-size: 16px;
}

.filters__button {
  display: flex;

  align-items: center;

  font-size: 14px;
  background: white;
  border: 2px solid $primaryColor;
  color: #000;
  padding: 16px 36px;
  transition: 0.3s;
  margin: {
    top: 8%;
  }
  border-radius: 4px;
  cursor: pointer;

  transition: background 200ms;

  &:hover {
    background: darken($lighterGray, 2%);
  }

  span {
    margin-left: 6px;
  }
}
</style>
